import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {inStoreFormId, atHomeFormId, apiUrl} from "./config/envSpecificVariables";

import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  useQuery,
  gql
} from "@apollo/client";

const client = new ApolloClient({
  uri: `${apiUrl}/graphql`,
  cache: new InMemoryCache()
});

const isInStore = window?.location?.pathname === "/instore"

const formId =  isInStore ? inStoreFormId : atHomeFormId

ReactDOM.render(
 <ApolloProvider client={client}>
	  <React.StrictMode>
	    <App isInStore={isInStore} formId={formId} />
	  </React.StrictMode>
  </ApolloProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
